module.exports = __webpack_public_path__ + "img/contact.2cc6c727.png";